"use client";
/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";
import { useWindowDimensions } from "@quales/utils/hooks";
import { useTranslations } from "next-intl";
import { useTheme } from "@quales/utils/theme";
import { useSnackbar } from "notistack";
import { useRouter } from "next/navigation";
import { useMutation } from "@apollo/client";
import { Button, Stack } from "@mui/material";
import { SubHeader } from "../ui/layout";
import ViewSubmittedFormComposite from "./ViewSubmittedFormComposite";
import { StoreFormResultDocument } from "@quales/data-access/graphql";
import { TaskContext } from "@quales/utils/context";
import MultiContextTaskOverview from "./task/composites/MultiContextTaskOverview";
import {
  PiDownload,
  PiFloppyDiskLight,
  PiCheckSquareOffset,
} from "react-icons/pi";
interface ViewFormWithActionsCompositeProps {
  formResultID: string | string[];
  formID: string | string[];
}

export const ViewFormWithActionsComposite = ({
  formResultID,
  formID,
}: ViewFormWithActionsCompositeProps) => {
  const t = useTranslations();
  const windowSize = useWindowDimensions();
  const theme = useTheme();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();
  const formResultRef = React.useRef();
  const { onTaskAction, onOpenTaskSideSheet, handleUpdateFormResultID } =
    React.useContext(TaskContext);

  const handleOnUpdateFormResultMutationCompleted = function () {
    setTimeout(() => {
      enqueueSnackbar(t("feedback.updateSuccess"), {
        variant: "success",
      });
    }, 1000);
  };

  const handleFormResultSubmit = () => {
    if (formResultRef && formResultRef.current) {
      //@ts-ignore
      formResultRef.current.onSubmit();
    }
  };

  const [saveForm] = useMutation(StoreFormResultDocument, {
    onCompleted: handleOnUpdateFormResultMutationCompleted,
  });

  const handleFormResultUpdate = (
    val: any,
    fomrSubmitted: boolean,
    formVersionVal: string
  ) => {
    if (fomrSubmitted) {
      saveForm({
        variables: {
          input: {
            formData: val,
            formID: formID.toString(),
            formVersion: formVersionVal,
            formResultID: formResultID.toString(),
          },
        },
      });
    }
  };

  const handleNewTaskRequest = () => {
    handleUpdateFormResultID(formResultID.toString());
    onOpenTaskSideSheet();
    onTaskAction(1);
  };

  const handlePDFDownload = () => {
    window.open("/files/formPdf/" + formResultID);
  };

  return (
    <Stack id="ViewFormWithActionsComposite" width={"100%"}>
      <SubHeader>
        <Stack direction="row" justifyContent="space-between" width={"100%"}>
          <Button color="secondary" onClick={() => router.back()}>
            {"<< " + t("labels.back")}
          </Button>
          <Stack direction={"row"} spacing={4} paddingRight={8}>
            <Button
              onClick={handleFormResultSubmit}
              sx={{
                color: theme.appColors.outline,
                // outline: theme.appColors.outline,
                outlineColor: "pink",
              }}
              type="submit"
              startIcon={
                <PiFloppyDiskLight color={theme.appColors.secondary} />
              }
              variant="outlined"
            >
              {t("labels.save")}
            </Button>
            <Button
              onClick={handlePDFDownload}
              type="submit"
              startIcon={<PiDownload color={theme.appColors.secondary} />}
              variant="outlined"
            >
              {t("labels.downloadPDF")}
            </Button>
            <Button
              onClick={handleNewTaskRequest}
              variant="outlined"
              startIcon={
                <PiCheckSquareOffset color={theme.appColors.secondary} />
              }
            >
              {t("common.newTask")}
            </Button>
          </Stack>
        </Stack>
      </SubHeader>
      <Stack direction={"row"} width="100%" spacing={6}>
        <Stack spacing={2} width="70%">
          <ViewSubmittedFormComposite
            formID={formResultID as string}
            useLiveValidate={true}
            // onFormvalueChanged={(val) => console.log(val)}
            onSubmitClicked={handleFormResultUpdate}
            ref={formResultRef}
          />
        </Stack>
        <Stack spacing={2} width={"30%"}>
          <MultiContextTaskOverview formResultID={formResultID} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ViewFormWithActionsComposite;
